module.exports = __webpack_public_path__ + "static/media/Pool1.7049393b.jpg";